$(document).ready(function() {
	var lang = $('html').attr('lang');

	/**
	 * Gestion resize + scroll
	 */
	// Resize de la fenêtre
	/*resize_window();
	$(window).resize(function() {
		resize_window();
	});*/

	// Gestion du scroll
	/*handle_scroll();
	$(window).scroll(function() {
		handle_scroll();
	});*/

	// Shifter
	if ($('body').hasClass('extranet')) {
		$.shifter({
			maxWidth: '4000px'
		});
	} else {
		$.shifter({
			maxWidth: '1024px'
		});
	}

	// WOW
	new WOW().init();

	// Lazyload
	lazyload();

	// Formulaires
	if ($('.form_common').length > 0) {
		$('.form_common').each(function() {
			var form = $(this);
			form.find('input, select, textarea').each(function() {
				var field = $(this);
				field.on('focus', function() {
					field.addClass('validation');
				});
			});
		});
	}

	$('.pageinfos select').on('change', function() {
		$(this).parents('form').submit();
	});

	// Rollover Mon compte
	$('.compte_submenu form input').focusin(function() {
		$('.item_compte').addClass('active');
	});
	$('.compte_submenu form input').focusout(function() {
		$('.item_compte').removeClass('active');
	});
	if (isTouchDevice()) {
		$('.item_compte > a').on('click', function(e) {
			if (!$(this).parent().hasClass('active')) {
				e.preventDefault();
				e.stopPropagation();
				$('.item_compte').addClass('active');
			}
		});
	}
	$('body').on('click', function(e) {
		if ($('.item_compte').hasClass('active') && !$('.compte_submenu').is(':hover')) {
			$('.item_compte').removeClass('active');
		}
	});

	$('.trigger_login').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.header_top_right .item_compte').toggleClass('active');
	});

	$('.burger_onglets a').hover(function(e) {
		$('.burger_onglets a').removeClass('active');
		$(this).addClass('active');
		$('.burger_onglet_content').stop(true, true).hide();
		$($(this).attr('rel')).stop(true, true).fadeIn(500);
	});
	if (isTouchDevice()) {
		$('.burger_onglets a').on('click', function(e) {
			e.preventDefault();
			$('.burger_onglets a').removeClass('active');
			$(this).addClass('active');
			$('.burger_onglet_content').stop(true, true).hide();
			$($(this).attr('rel')).stop(true, true).fadeIn(500);
		});
	}
});

function resize_window() {

}

function handle_scroll() {

}

/**
 * Facebook Connect
 */
function facebookSignOut() {
	if ($('#fb-root').length > 0) {
		FB.getLoginStatus(function(response) {
			console.log(response);
			if (response.status === 'connected') {
				FB.logout(function(response) {
					console.log(response);
					console.log('User signed out from Facebook.');
				});
			}
		});
	}
}

/**
 * Google Connect
 */
function onGoogleSuccess(googleUser) {
	var profile = googleUser.getBasicProfile();
	var id_token = googleUser.getAuthResponse().id_token;
	//console.log('ID: ' + profile.getId());
	//console.log('Email: ' + profile.getEmail());
	//console.log('Full Name: ' + profile.getName());
	//console.log('Given Name: ' + profile.getGivenName());
	//console.log('Family Name: ' + profile.getFamilyName());
	//console.log('Image URL: ' + profile.getImageUrl());
	console.log('ID Token: ' + id_token);

	$.ajax({
		type: 'GET',
		url: lang_path + '/signup/google/index.html',
		data: {
			google_id: profile.getId(),
			email: profile.getEmail(),
			first_name: profile.getGivenName(),
			last_name: profile.getFamilyName(),
			google_id_token: id_token,
		},
		success: function(data) {
			location.href = $('#g-signin').data('redirect');
		}
	});
}

function onGoogleFailure(error) {
	console.log(error);
}

function onGoogleLoad() {
	gapi.load('auth2', function() {
		gapi.auth2.init();
	});

	if ($('#g-signin').length > 0) {
		gapi.signin2.render('g-signin', {
			'scope': 'profile email',
			'width': 240,
			'height': 50,
			'longtitle': true,
			'theme': 'dark',
			'onsuccess': onGoogleSuccess,
			'onfailure': onGoogleFailure
		});
	}
}

function googleSignOut() {
	if ($('meta[name="google-signin-client_id"]').length > 0) {
		var auth2 = gapi.auth2.getAuthInstance();
		auth2.signOut().then(function() {
			console.log('User signed out from Google.');
		});
	}
}

function signOut() {
	facebookSignOut();
	googleSignOut();
}
